<ul ngbNav #nav="ngbNav" class="nav-pills nav-fill align-items-center" [destroyOnHide]="false">
  @for(tab of config; track tab.id){
  <li [ngbNavItem]="tab.id">
    <button ngbNavLink class="btn btn-info btn-info-ghost fs-10">
      {{ tab.title | translate }}
    </button>
    <ng-template ngbNavContent>
      <ng-container
        *ngComponentOutlet="tab.content.content; inputs: tab.content.data"
      />
    </ng-template>
  </li>
  }
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
